import {
  WSCheckboxToggle,
  WSElement,
  WSElementProps,
  WSFormOld,
  WSTextInput
} from "@wingspanhq/fe-component-library";
import * as Yup from "yup";
import { ObjectShape } from "yup/lib/object";
import { ILabelsDictionary } from "../../../modules/BulkImporter/utils/getUploadedFilename";
import { convertDataTypeBooleanToBoolean } from "../../utils/convertDataTypeBoolean";
import { AttributeDataType, CustomField } from "@wingspanhq/wingspan-api-sdk";

type Props = {
  name: string;
  fields: CustomField[];
  defaultValues?: { [key: string]: string | boolean | undefined };
} & WSElementProps;

export const FormPartialCustomFields: React.FC<Props> = ({
  name,
  fields,
  defaultValues,
  ...elementProps
}) => {
  if (fields.length === 0) {
    return null;
  }

  return (
    <WSElement {...elementProps}>
      {fields.map(field => {
        const key = field.key ?? "";

        return field.dataType === AttributeDataType.STRING ? (
          <WSFormOld.Field
            mb="XL"
            key={key}
            name={`${name}.${key}`}
            label={field.name + (field.isRequired ? "" : " (optional)")}
            component={WSTextInput}
            defaultValue={(defaultValues?.[key] || "") as any}
          />
        ) : (
          <WSFormOld.Field
            mb="XL"
            key={key}
            name={`${name}.${key}`}
            component={WSCheckboxToggle}
            componentProps={{ label: field.name }}
            defaultValue={(defaultValues?.[key] || false) as any}
          />
        );
      })}
    </WSElement>
  );
};

export const getValidationSchemaCustomFields = (fields: CustomField[]) => {
  const validationSchemaShape: ObjectShape = {};

  fields.forEach(field => {
    if (field.isRequired && field.key) {
      if (field.dataType === AttributeDataType.BOOLEAN) {
        validationSchemaShape[field.key] = Yup.boolean().required(
          `${field.name} is required`
        );
      } else {
        validationSchemaShape[field.key] = Yup.string().required(
          `${field.name} is required`
        );
      }
    }
  });

  return Yup.object().shape(validationSchemaShape);
};

export const getFormDataCustomFields = (
  fields: CustomField[],
  data: ILabelsDictionary
) => {
  const defaultValues: any = {};
  fields.forEach(field => {
    if (!field.key) {
      return;
    }
    const key = field.key;

    switch (field.dataType) {
      case AttributeDataType.STRING:
        defaultValues[key] = data[key] ? String(data[key]) : "";
        break;
      case AttributeDataType.BOOLEAN:
        defaultValues[key] = convertDataTypeBooleanToBoolean(data[key]);
        break;
    }
  });
  return defaultValues;
};

export const getRequestDataCustomFields = (formData: {
  [key: string]: string | boolean | undefined;
}) => {
  const labels: any = {};
  Object.keys(formData).forEach(key => {
    labels[key] = String(formData[key]);
  });
  return labels;
};
